import { Col, Label, ReactSelectBox, Row } from "client/CommonComponents"

const AddPositionContainer = (props: any) => {
    const {
        titleDropDownListTemp,
        positionOptions,
        selectedAddTitle,
        selectedAddPosition,
        onPositionChange,
        onTitleChange,
        addPositionError,
        addtitleError,
        isEditPosition
    } = props

    return (
        <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={'mb-3'}>
                <Label required data-attribute="AddPosition_Default_Label">Position#</Label>
                <ReactSelectBox
                    options={positionOptions}
                    onChange={(e: any) => onPositionChange(e)}
                    value={selectedAddPosition}
                    isDisabled={isEditPosition}
                    isSearchable={true}
                    className={addPositionError?.length ? 'controlValidation' : ''}  data-attribute="AddPosition_Default_SearchSelectBox" />
                {addPositionError?.length ? <p className='validMessage'>{addPositionError}</p> : null}
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
                <Label required data-attribute="AddPosition_Default_Label_2">Title</Label>
                <ReactSelectBox
                    options={titleDropDownListTemp}
                    onChange={(e: any) => onTitleChange(e)}
                    value={selectedAddTitle}
                    isSearchable={true} 
                    className={addtitleError?.length ? 'controlValidation' : ''}  data-attribute="AddPosition_Default_SearchSelectBox_2" />
                {addtitleError?.length ? <p className='validMessage'>{addtitleError}</p> : null}
            </Col>
        </Row>
    )
}

export default AddPositionContainer